//#region src/modules/menubar/utils/search.ts
var includes = (string, term) => {
	return new RegExp(term, "i").test(string);
};
/**
* Recursively searches for MenuItems by label.
* Case-insensitive.
* * @param items - The array of MenuItems to search through.
* @param items
* @param query - The string to search for within the labels.
* @returns A flat array of matching MenuItems.
*/
var searchMenuByLabel = (items, query) => {
	if (!query || query.trim() === "") return items;
	const filterNodes = (nodes) => {
		return nodes.map((node) => {
			const matchesSelf = includes(node.label, query);
			const matchingChildren = node.children ? filterNodes(node.children) : [];
			if (matchesSelf || matchingChildren.length > 0) return {
				...node,
				children: matchingChildren
			};
			return null;
		}).filter((item) => item !== null);
	};
	return filterNodes(items);
};
//#endregion
export { searchMenuByLabel };
